import css from '@/pages/Equipment/pages/LiftPage/pages/LiftMonitoring/lifMonitoring.module.css'
import Tabs from '@/shared/Tabs'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import useEquipment from '@/pages/Equipment/hooks/useEquipment.ts'
import { ITab } from '@/shared/Tabs/tabs.types.ts'
import useQueryState from '@/shared/hooks/useQueryState'
import LiftPlateContactsMatrixRange from '../components/LiftPlateContactsMatrix/LiftPlateContactsMatrixRange'
import LiftIndicatorsRange from '../components/LiftIndicators/LiftIndicatorsRange'
import LiftWinchPowerRange from '../components/LiftWinchPower/LiftWinchPowerRange'
import LiftPlateContactsMatrixRealtime from '../components/LiftPlateContactsMatrix/LiftPlateContactsMatrixRealtime'
import LiftIndicatorsRealtime from '../components/LiftIndicators/LiftIndicatorsRealtime'
import LiftWinchPowerRealtime from '../components/LiftWinchPower/LiftWinchPowerRealtime'
import { TTimeSelectionModeType } from '../useMonitoringModeCtrl'
import LiftCard from '../../../components/LiftCard'
import LiftCardRange from '../../../components/LiftCard/LiftCardRange'

interface IProps {
  contentType: TTimeSelectionModeType
  equipmentId: IEquipment['id']
  selectedDate: Date

  tsFrom: number
  tsTo: number
  tsCurrent: number
  onSelectedTabChanged: () => void
}

const MonitoringTabContent = (props: IProps) => {
  const [selectedTab, setSelectedTab] = useQueryState('selectedTab', 'matrix-contacts', undefined, { replace: true })
  const equipment = useEquipment(props.equipmentId)

  const renderWidgetsTypeRange = () => {
    switch (selectedTab) {
      case 'matrix-contacts':
        return <LiftPlateContactsMatrixRange {...props} equipmentId={equipment.id} />
      case 'indications':
        return <LiftIndicatorsRange {...props} equipmentId={equipment.id} />
      case 'winch-power':
        return <LiftWinchPowerRange {...props} equipmentId={equipment.id} />
      default:
        return null
    }
  }

  const renderWidgetsTypeRealtime = () => {
    switch (selectedTab) {
      case 'matrix-contacts':
        return (
          <LiftPlateContactsMatrixRealtime
            equipmentId={equipment.id}
            live={props.contentType === 'live'}
            ts={props.selectedDate?.getTime()}
          />
        )
      case 'indications':
        return (
          <LiftIndicatorsRealtime
            equipmentId={equipment.id}
            live={props.contentType === 'live'}
            ts={props.selectedDate?.getTime()}
          />
        )
      case 'winch-power':
        return (
          <LiftWinchPowerRealtime
            equipmentId={equipment.id}
            live={props.contentType === 'live'}
            ts={props.selectedDate?.getTime()}
          />
        )
      default:
        return null
    }
  }

  const renderLiftCard = () => {
    if (props.contentType === 'range') return <LiftCardRange {...props} equipmentId={equipment.id} />
    return (
      <LiftCard equipmentId={equipment.id} live={props.contentType === 'live'} ts={props.selectedDate?.getTime()} />
    )
  }

  const renderWidget = () => {
    if (props.contentType === 'range') return renderWidgetsTypeRange()
    return renderWidgetsTypeRealtime()
  }

  return (
    <div className="mt16" style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
      <div style={{ minHeight: 0, display: 'flex', flexDirection: 'row', gap: '16px', height: '100%' }}>
        <div className={css.mainCard}>
          <Tabs
            tabs={monitoringTabs}
            onSelect={(v) => (setSelectedTab(v), props.onSelectedTabChanged())}
            selectedTab={selectedTab}
          />
          {renderWidget()}
        </div>
        {renderLiftCard()}
      </div>
    </div>
  )
}

const monitoringTabs: ITab[] = [
  { title: 'Матрица', id: 'matrix-contacts' },
  { title: 'Индикации', id: 'indications' },
  { title: 'Питание лебедки', id: 'winch-power' },
]

export default MonitoringTabContent
